import { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSearchParams } from 'react-router-dom';
import Container from '@mui/material/Container';
import MKBox from 'components/MaterialKit/MKBox';
import { handleErrorResponse } from 'utils/general';
import { withLoading } from 'utils/hoc';
import { useAuth } from 'contexts/auth';
import { getLocaleMap } from 'utils/locales';
import { getModel } from 'api/monitors';
import EditModelForm from './EditModelForm';

const EditModelSection = ({
  setLoading,
  title_color,
  title_font_size,
  title_font_weight,
  edit_button_color,
  edit_font_color,
  save_button_color,
  save_button_font_color,
  back_button_color,
  back_button_font_color,
}) => {
  const [lm, setLm] = useState({});

  useEffect(() => {
    getLocaleMap(['labels_edit', 'labels_create'])
      .then((response) => {
        setLm(response);
      });
  }, []);

  const [model, setModel] = useState(null);
  const [searchParams] = useSearchParams();
  const { setAuth } = useAuth();
  const modelId = searchParams.get('model_id');

  const fetchModelFromApi = useCallback(() => {
    if (!modelId) {
      return Promise.resolve();
    }
    setLoading(true);
    return getModel(modelId, { $expand: 'default_image' })
      .then(({ data }) => {
        setModel(data);
      })
      .catch((error) => {
        handleErrorResponse(error, setAuth);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [modelId, setAuth, setLoading]);

  useEffect(() => {
    fetchModelFromApi();
  }, [fetchModelFromApi]);

  return (
    <MKBox flex={1} py="2rem">
      <Container>
        <div style={{ marginBottom: 10, color: title_color, fontSize: title_font_size, fontWeight: title_font_weight }}>
          {model ? `Edit Product [${model?.id_name}]` : 'Create New Product'}
        </div>
        <EditModelForm
          model={model}
          editButtonColor={edit_button_color}
          editFontColor={edit_font_color}
          saveButtonColor={save_button_color}
          saveButtonFontColor={save_button_font_color}
          backButtonColor={back_button_color}
          backButtonFontColor={back_button_font_color}
        />
      </Container>
    </MKBox>
  );
};

EditModelSection.propTypes = {
  setLoading: PropTypes.func,
  title_color: PropTypes.string,
  title_font_size: PropTypes.string,
  title_font_weight: PropTypes.string,
  edit_button_color: PropTypes.string,
  edit_font_color: PropTypes.string,
  save_button_color: PropTypes.string,
  save_button_font_color: PropTypes.string,
  back_button_color: PropTypes.string,
  back_button_font_color: PropTypes.string,
};

export default withLoading(EditModelSection);
